import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import FullCoverageWarrantyWrapper from "@components/layouts/fullCoverageWarrantyWrapper";

export default function FullCoverageWarrantyHome(): ReactElement {
    return (
        <FullCoverageWarrantyWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#FE786C" />
                </div>
                <FormSection iconsFillColor="#4F96F6" />
            </div>
        </FullCoverageWarrantyWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
